<template>
  <div class="diario" v-loading="loading">
    <div class="action" v-if="actionBar">
      <el-button class="WEB-button WEB-button-alternative" v-if="enableAction('add')" @click="add">{{
        $t('btn.add').toUpperCase()}}</el-button>
      <el-button class="WEB-button WEB-button-primary" v-if="enableAction('sendAll')" @click="send()">{{
        $t('btn.sendAll').toUpperCase()}}</el-button>
    </div>
    <div style="marginTop:25px" v-else></div>
    <el-table :data="diario" @row-click="open" class="custom-table">
      <el-table-column header-align="center" align="center" width="50">


        <template slot-scope="scope" slot="header">
          <div class="icon-title">
            <el-popover placement="top" v-model="visibleInfo" :key="scope.toString()">
              <div>
                <div>
                  <icon name="riv-circle" class="status-saved" scale="0.8"></icon>
                  <span>{{ $t('statusDett.0') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-send" scale="0.8"></icon>
                  <span>{{ $t('statusDett.1') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-rejected" scale="0.8"></icon>
                  <span>{{ $t('statusDett.2') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-approved" scale="0.8"></icon>
                  <span>{{ $t('statusDett.3') }}</span>
                </div>
              </div>

              <span slot="reference">
                <icon class="pointer" name="riv-help" scale="1"></icon>
              </span>
            </el-popover>

          </div>
        </template>


        <template slot-scope="scope">
          <div class="data-wrapper">
            <el-tooltip class="item" effect="dark" :content="$t('statusDett.' + scope.row.statoAvanz)"
              placement="top-start">
              <icon :name="getStatoIcon_dett(scope.row.statoAvanz)" :class="getStatoClass_dett(scope.row.statoAvanz)"
                scale="0.8"></icon>
            </el-tooltip>
          </div>
        </template>

      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('diario.label.giorno')" width="100">

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ scope.row.giorno | formattaData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('diario.label.orario')" width="100">

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ scope.row.oraDal | formattaHours }} / {{ scope.row.oraAl | formattaHours }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="desDest" :label="$t('diario.label.destinazione')" min-width="200">
      </el-table-column>

      <el-table-column width="50" header-align="center" align="center">

        <template slot-scope="scope" slot="header">
          <div class="icon-title">
            <el-tooltip class="item" effect="dark" :content="$t('diario.label.mensa')" placement="top-start"
              :key="scope.toString()">
              <icon name="riv-mensa" scale="1.1"></icon>
            </el-tooltip>
          </div>
        </template>

        <template slot-scope="scope">
          <div class="data-wrapper">
            <el-tooltip v-if="scope.row.idMensa !== ''" class="item" effect="dark"
              :content="$t('statusDett.' + scope.row.statoMensa)" placement="top-start">
              <icon :name="getStatoIcon_dett(scope.row.statoMensa)" :class="getStatoClass_dett(scope.row.statoMensa)"
                scale="0.8"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="50" header-align="center" align="center">

        <template slot-scope="scope" slot="header">
          <div class="icon-title">
            <el-tooltip class="item" effect="dark" :content="$t('diario.label.alloggio')" placement="top-start"
              :key="scope.toString()">
              <icon name="riv-alloggio" scale="1.1"></icon>
            </el-tooltip>
          </div>
        </template>

        <template slot-scope="scope">
          <div class="data-wrapper">
            <el-tooltip v-if="scope.row.idAlloggio !== ''" class="item" effect="dark"
              :content="$t('statusDett.' + scope.row.statoAlloggio)" placement="top-start">
              <icon :name="getStatoIcon_dett(scope.row.statoAlloggio)"
                :class="getStatoClass_dett(scope.row.statoAlloggio)" scale="0.8"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="50" header-align="center" align="center">

        <template slot-scope="scope">
          <div class="data-wrapper" style="cursor: pointer">
            <el-tooltip class="item" effect="dark" v-if="enableAction('send', scope.row)" :content="$t('btn.sendResp')"
              placement="top-start">
              <icon name="riv-sendMail" scale="1.2" @click.native.stop="send(scope.row)"
                v-if="enableAction('send', scope.row)"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="50" header-align="center" align="center" v-if="enableAction('del')">

        <template slot-scope="scope">
          <div class="actions">
            <icon name="riv-delete2" scale="1.2" @click.native.stop="del(scope.row)"></icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" class="custom-pagination" background
      layout="prev, pager, next" :total="nrItems" :page-size="pag_for" @current-change="changePage">
    </el-pagination>

    <!-- Dialog di creazione di una nuova richiesta di ferie -->
    <el-dialog :title="($t('diario.label.diario').toUpperCase())" :visible.sync="showModal" class="custom-dialog"
      :append-to-body="true" custom-class="offset-5 col-14">

      <el-form class="" :disabled="trasferta.terminata === 'T'">
        <div class="elemento row row-custom"
          :class="[!this.validaDiario && (this.form.giorno === undefined || this.form.giorno === null) ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('diario.label.giorno') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="form.giorno">
              <el-option v-for="item in picker_days" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaDiario && (this.form.oraDal === undefined || this.form.oraDal === null || this.form.oraAl === undefined || this.form.oraAl === null) ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('diario.label.orario') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-time-picker v-model="form.oraDal" format="HH:mm" :placeholder="$t('diario.label.inizio')"
              value-format="HH:mm" :disabled="form.id != ''">
            </el-time-picker>
            <el-time-picker v-model="form.oraAl" format="HH:mm" :placeholder="$t('diario.label.fine')"
              value-format="HH:mm" :disabled="form.id != ''">
            </el-time-picker>
            <!--<el-time-select class="dt-picker time"
                            v-model="form.oraDal"
                            placeholder="Select time"
                            :picker-options="{start: '00:00',step: '00:15',end: '24:00', format:'HH:mm'}"
                            :disabled="form.id != ''">
            </el-time-select>
            <el-time-select class="dt-picker time"
                            v-model="form.oraAl"
                            placeholder="Select time"
                            :picker-options="{start: form.oraDal,step: '00:15',end: '24:00', format:'HH:mm'}"
                            :disabled="form.id != ''">
            </el-time-select>-->
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaDiario && (this.form.destinazione === undefined || this.form.destinazione === '') ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('diario.label.destinazione') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="form.destinazione" filterable allow-create>
              <el-option v-for="item in tbl_genSta" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaDiario && (this.form.socFat === undefined || this.form.socFat === '') ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('diario.label.socFat') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="form.socFat" @change="loadUffRep" filterable>
              <el-option v-for="item in tbl_socFat" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaDiario && (this.form.ufficio === undefined || this.form.ufficio === '') ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('diario.label.uffRep') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="form.ufficio" filterable>
              <el-option v-for="item in tbl_uffRep" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('diario.label.motivo') }}
          </div>
          <div class="my-value col-16 no-padding">

            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="" v-model="form.motivo">
            </el-input>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('diario.label.note') }}
          </div>
          <div class="my-value col-16 no-padding">

            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="" v-model="form.notaDip">
            </el-input>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-area col-24 no-padding">
            {{ $t('diario.label.note') }}
          </div>

          <div class="col-12 no-padding-left">
            <div class="elemento row row-custom">
              <div class="my-label col-24 no-padding">
                {{ $t('diario.label.mensa') }}
                <el-checkbox v-model="form.checkedMensa" class="riva-header-checkbox"
                  style="float: left; margin-right: 10px;"></el-checkbox>
              </div>
              <div class="my-value col-24 no-padding">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="" v-model="form.notaMensa"
                  :disabled="!form.checkedMensa">
                </el-input>
              </div>
            </div>
          </div>
          <div class="col-12 no-padding-left" v-if="trasferta.tipoTrasferta === 'GIO'">
            <div class="elemento row row-custom">
              <div class="my-label col-24 no-padding">
                {{ $t('diario.label.alloggio') }}
                <el-checkbox v-model="form.checkedAlloggio" class="riva-header-checkbox"
                  style="float: left; margin-right: 10px;"></el-checkbox>
              </div>
              <div class="my-value col-24 no-padding">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder=""
                  v-model="form.notaAlloggio" :disabled="!form.checkedAlloggio">
                </el-input>
              </div>
            </div>
          </div>
        </div>

        <div v-if="form.statoAvanz !== '0' && form.statoAvanz !== undefined">
          <div class="elemento row row-custom">
            <div class="my-area col-24 no-padding">
              {{ $t('diario.label.segreteria') }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.descrTipo !== '' || form.nomeHotel !== ''">
            <div class="my-label col-8 no-padding">
              {{ form.descrTipo }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.nomeHotel }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.indirizzo !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('diario.label.indirizzo') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.indirizzo }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.numeroCamera !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('diario.label.room') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.numeroCamera }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.notaSegAlloggio !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('diario.label.noteSegreteriaAlloggio') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.notaSegAlloggio }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.notaSegMensa !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('diario.label.noteSegreteriaMensa') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.notaSegMensa }}
            </div>
          </div>
          <div v-if="form.nomeFile !== ''" class="elemento row row-custom">
            <div @click="getDoc(form.nomeFile)">
              <icon name="riv-download" scale="1.5"></icon>
              <span class="truncate applicazione">{{ form.nomeFile }}</span>
            </div>
          </div>
        </div>

      </el-form>

      <span slot="footer" class="">
        <el-button class="WEB-button WEB-button-alternative" size="small" v-if="trasferta.terminata === 'T'"
          @click="close">{{ $t('btn.close') }}</el-button>
        <el-button class="WEB-button WEB-button-alternative" size="small" v-if="trasferta.terminata !== 'T'"
          @click="close">{{ $t('btn.annulla') }}</el-button>
        <el-button class="WEB-button WEB-button-primary" v-if="trasferta.terminata !== 'T'" @click="checkSave()">{{
          $t('btn.salva').toUpperCase() }}</el-button>
      </span>

    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Diario',
  props: ['trasferta', 'tbl_genSta', 'tbl_socFat', 'actionBar'],
  i18n: {
    messages: {
      it_IT: {
        diario: {
          label: {
            giorno: 'Giorno',
            orario: 'Orario',
            destinazione: 'Destinazione',
            mensa: 'Mensa',
            alloggio: 'Alloggio',
            diario: 'Diario di Viaggio',
            socFat: 'Soc. di Fatturazione',
            uffRep: 'Ufficio/Reparto',
            motivo: 'Motivo',
            note: 'Nota',
            segreteria: 'Segreteria',
            indirizzo: 'Indirizzo',
            room: 'N° Camera',
            noteSegreteria: 'Note Segreteria',
            noteSegreteriaAlloggio: 'Note Segr. Alloggio',
            noteSegreteriaMensa: 'Note Segr. Mensa',
            inizio: 'Inizio',
            fine: 'Fine'
          },
          msg: {
            saveMensa: 'Salvataggio Mensa',
            saveAlloggio: 'Salvataggio Alloggio',
            datiObbligatoriMancanti: 'Dati obbligatori mancanti'
          }
        }
      },
      fr_FR: {
        diario: {
          label: {
            giorno: 'Jour',
            orario: 'Horaire',
            destinazione: 'Destination',
            mensa: 'Repas',
            alloggio: 'Hébergement',
            diario: 'Détail du voyage',
            socFat: 'Société de facturation',
            uffRep: 'Bureau/département',
            motivo: 'Motif',
            note: 'Notes',
            segreteria: 'Secrétaire',
            indirizzo: 'Adresse',
            room: 'N° de chambre',
            noteSegreteria: 'Annotations de la Secrétaire',
            noteSegreteriaAlloggio: 'Annot. Sécr. S/Logement',
            noteSegreteriaMensa: 'Annot. Sécr. S/Repas',
            inizio: 'de',
            fine: 'à'
          },
          msg: {
            saveMensa: 'Sauvegarder Repas',
            saveAlloggio: 'Sauvegarder Hébergement',
            datiObbligatoriMancanti: 'Données obligatoires manquantes'
          }
        }
      },
      es_ES: {
        diario: {
          label: {
            giorno: 'Día',
            orario: 'Horas',
            destinazione: 'Destino',
            mensa: 'Comedor',
            alloggio: 'Alojamiento',
            diario: 'Agenda de viaje',
            socFat: 'Sociedad de facturación',
            uffRep: 'Oficina/Empresa',
            motivo: 'Referencia',
            note: 'Nota',
            segreteria: 'Secretaria',
            indirizzo: 'Dirección',
            room: 'Habitación',
            noteSegreteria: 'Nota de la Secretaria',
            noteSegreteriaAlloggio: 'Nota Secr. Alojamiento',
            noteSegreteriaMensa: 'Nota Secr. Comedor',
            inizio: 'de',
            fine: 'a'
          },
          msg: {
            saveMensa: 'Comida guardada',
            saveAlloggio: 'Alojamiento guardado',
            datiObbligatoriMancanti: 'Faltan datos obligatorios'
          }
        }
      },
      de_DE: {
        diario: {
          label: {
            giorno: 'Tag',
            orario: 'Zeitraum',
            destinazione: 'Reiseziel',
            mensa: 'Kantine',
            alloggio: 'Unterkunft',
            diario: 'Reiseplan',
            socFat: 'Rechnungsfirma',
            uffRep: 'Büro/Abteilung',
            motivo: 'Grund',
            note: 'Notiz',
            segreteria: 'Sekretariat',
            indirizzo: 'Adresse',
            room: 'Zimmer',
            noteSegreteria: 'Notiz des Sekretariat',
            noteSegreteriaAlloggio: 'Notiz des Sekretariat Unterkunft',
            noteSegreteriaMensa: 'Notiz des Sekretariat Kantine',
            inizio: 'Start',
            fine: 'Ende'
          },
          msg: {
            saveMensa: 'Kantine retten',
            saveAlloggio: 'Unterkunft sparen',
            datiObbligatoriMancanti: 'Fehlende Pflichtangaben'
          }
        }
      },
      en_GB: {
        diario: {}
      }
    }
  },
  data() {
    return {
      loading: false,
      diario: [],
      currentPage: 1,
      pag_for: 8,
      pag_order: 'DD',
      nrPages: 0,
      nrItems: 0,
      showModal: false,
      form: {},
      tbl_uffRep: [],
      visibleInfo: false,
      validaDiario: true,
      daInoltrare: '0',
      picker_days: []
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    },
    formattaHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    }
  },
  activated: function () {
    this.loadDiario()
  },
  mounted: function () {
    this.loadDiario()

    moment.locale(this.$i18n.locale)

    const dataDal = moment(this.trasferta.dataDal, 'YYYYMMDD')
    const dataAl = moment(this.trasferta.dataAl, 'YYYYMMDD')
    const numDays = dataAl.diff(dataDal, 'days') + 1

    this.picker_days = Array.from({ length: numDays }, (_, i) => {
      const giorno = dataDal.clone().add(i, 'days')
      return {
        value: giorno.format('YYYYMMDD'),
        label: giorno.format('dddd Do MMM YYYY')
      };
    });
  },
  methods: {
    loadDiario: function () {
      this.$set(this, 'diario', [])
      this.loading = true
      this.$http.get('trasferte/' + this.$store.state.country + '/diario', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.pag_order
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.diario = response.body.data
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
              this.$set(this, 'daInoltrare', response.body.attrib.daInoltrare)
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this, 'diario', [])
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.loading = false
        })
    },
    add: function () {
      this.validaDiario = true
      this.$set(this, 'form', {})
      this.$set(this.form, 'giorno', this.trasferta.dataDal)
      this.$set(this.form, 'destinazione', this.trasferta.desMan === '' ? this.trasferta.destinazione : this.trasferta.desMan)
      this.$set(this.form, 'motivo', this.trasferta.notaDip.split("\\n").join("\n"))
      this.$set(this.form, 'checkedMensa', false)
      this.$set(this.form, 'statoMensa', "0")
      this.$set(this.form, 'checkedAlloggio', false)
      this.$set(this.form, 'statoAlloggio', "0")
      this.form.id = ''
      this.form.idMensa = ''
      this.form.idAlloggio = ''
      this.form.idTrasferta = this.trasferta.idTrasferta
      this.showModal = true
    },
    open: function (row, event, column) {
      this.validaDiario = true
      this.$set(this, 'form', {})
      this.loadUffRep(row.socFat)
      this.form.idTrasferta = row.idTrasferta
      this.form.id = row.id
      this.form.statoAvanz = row.statoAvanz
      this.$set(this.form, 'giorno', row.giorno)
      this.$set(this.form, 'oraDal', moment(row.oraDal, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'oraAl', moment(row.oraAl, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'destinazione', row.destinazione)
      this.$set(this.form, 'socFat', row.socFat)
      this.$set(this.form, 'ufficio', row.ufficio)
      this.$set(this.form, 'motivo', row.motivo.split("\\n").join("\n"))
      this.$set(this.form, 'notaDip', row.notaDip.split("\\n").join("\n"))
      if (row.idAlloggio != '') {
        this.$set(this.form, 'checkedAlloggio', true)
        //this.form.checkedAlloggio = true
      } else {
        this.$set(this.form, 'checkedAlloggio', false)
        this.$set(this.form, 'statoAlloggio', "0")
      }
      if (row.idMensa != '') {
        this.$set(this.form, 'checkedMensa', true)
        //this.form.checkedMensa = true
      } else {
        this.$set(this.form, 'checkedMensa', false)
        this.$set(this.form, 'statoMensa', "0")
      }
      this.form.idAlloggio = row.idAlloggio
      this.form.idMensa = row.idMensa
      this.$set(this.form, 'notaAlloggio', '')
      this.$set(this.form, 'notaMensa', '')
      if (this.form.idAlloggio === '' && this.form.idMensa === '') {
        this.showModal = true
      } else {
        this.loadDettaglio(row.id, row.idAlloggio, row.idMensa)
      }
    },
    close: function () {
      this.showModal = false
    },
    checkSave: function () {
      this.validaDiario = true
      if (this.form.giorno === null || this.form.giorno === undefined) {
        this.validaDiario = false
      }
      if (this.form.oraDal === null || this.form.oraDal === undefined) {
        this.validaDiario = false
      }
      if (this.form.oraAl === null || this.form.oraAl === undefined) {
        this.validaDiario = false
      }
      if (this.form.destinazione === '' || this.form.destinazione === undefined) {
        this.validaDiario = false
      }
      if (this.form.socFat === '' || this.form.socFat === undefined) {
        this.validaDiario = false
      }
      if (this.form.ufficio === '' || this.form.ufficio === undefined) {
        this.validaDiario = false
      }

      if (this.validaDiario) {
        this.save()
      } else {
        this.$message.error(this.$i18n.t('diario.msg.datiObbligatoriMancanti'))
      }
    },
    save: function () {
      let _this = this
      this.loading = true
      let opMensa = ''
      if (this.form.idMensa === '' && this.form.checkedMensa) {
        opMensa = '*ADD'
      } else if (this.form.id != '' && this.form.idMensa != '' && !this.form.checkedMensa) {
        opMensa = '*DEL'
      } else if (this.form.id != '' && this.form.idMensa != '' && this.form.checkedMensa) {
        opMensa = '*UPD'
      }
      let opAlloggio = ''
      if (this.form.idAlloggio === '' && this.form.checkedAlloggio) {
        opAlloggio = '*ADD'
      } else if (this.form.id != '' && this.form.idAlloggio != '' && !this.form.checkedAlloggio) {
        opAlloggio = '*DEL'
      } else if (this.form.id != '' && this.form.idAlloggio != '' && this.form.checkedAlloggio) {
        opAlloggio = '*UPD'
      }
      let objMensa = {
        'id': this.form.id === '' ? '' : this.form.idMensa,
        'operazione': opMensa,
        'tipo': 'P',
        'notaDip': this.form.notaMensa,
        'giorno': this.form.giorno,
        'statoAvanz': this.form.statoMensa
      }
      let objAlloggio = {
        'id': this.form.id === '' ? '' : this.form.idAlloggio,
        'operazione': opAlloggio,
        'notaDip': this.form.notaAlloggio,
        'giorno': this.form.giorno,
        'statoAvanz': this.form.statoAlloggio
      }
      let obj = {
        'idTrasferta': this.form.idTrasferta,
        'id': this.form.id === '' ? '' : this.form.id,
        'operazione': this.form.id === '' ? '*ADD' : '*UPD',
        'giorno': this.form.giorno,
        'oraDal': moment(this.form.oraDal, 'HH:mm').format('HH.mm.ss'),
        'oraAl': moment(this.form.oraAl, 'HH:mm').format('HH.mm.ss'),
        'destinazione': this.form.destinazione,
        'ufficio': this.form.ufficio,
        'socFat': this.form.socFat,
        //'cliente': this.form.socFat,
        'motivo': this.form.motivo,
        'notaDip': this.form.notaDip,
        'mensa': objMensa,
        'alloggio': objAlloggio
      }
      if (this.form.id != '') {
        delete obj['oraDal']
        delete obj['oraAl']
      }
      if (opMensa === '') {
        delete obj['mensa']
      }
      if (opAlloggio === '') {
        delete obj['alloggio']
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/diario', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.respDiario.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })

            if (response.body.respMensa != undefined) {
              setTimeout(function () {
                // Notifico l'azione di salvataggio Alloggio
                //Notifico il salvataggio del giorno
                _this.$notify({
                  title: _this.$i18n.t('diario.msg.saveMensa'),
                  message: response.body.respMensa.msg[0].msgTxt,
                  type: response.body.respMensa.rc === 0 ? 'success' : 'error',
                  duration: process.env.duration
                })
              }, 400)
            }

            if (response.body.respAlloggio != undefined) {
              setTimeout(function () {
                // Notifico l'azione di salvataggio Alloggio
                //Notifico il salvataggio del giorno
                _this.$notify({
                  title: _this.$i18n.t('diario.msg.saveAlloggio'),
                  message: response.body.respAlloggio.msg[0].msgTxt,
                  type: response.body.respAlloggio.rc === 0 ? 'success' : 'error',
                  duration: process.env.duration
                })
              }, 800)
            }
            this.loadDiario()
            this.showModal = false
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    del: function (row) {
      this.loading = true
      this.$http.delete('trasferte/' + this.$store.state.country + '/diario/' + row.idTrasferta + '/' + row.id)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadDiario()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    send: function (row) {
      let obj = {}

      if (row != undefined) {
        obj = {
          idTrasferta: this.trasferta.idTrasferta,
          statoAvanz: '1',
          righeDiario: [{
            id: row.id
          }],
          numRigheDiario: 1
        }
      } else {
        obj = {
          idTrasferta: this.trasferta.idTrasferta,
          statoAvanz: '1',
          numRigheDiario: 0
        }
      }

      this.$http.post('trasferte/' + this.$store.state.country + '/statodiario', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadDiario()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.loadDiario()
    },
    loadAlloggio: function (idRiga, id) {
      this.$http.get('trasferte/' + this.$store.state.country + '/alloggi', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          id: id,
          idRiga: idRiga,
          pag_action: 'BEGIN',
          pag_from: 1,
          pag_for: 20,
          pag_order: 'DD'
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.form.notaAlloggio = response.body.data[0].notaDip
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    loadDettaglio: function (idRiga, idAlloggio, idMensa) {
      this.loading = true
      this.$http.get('trasferte/' + this.$store.state.country + '/dettdiario', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          idRiga: idRiga,
          idAlloggio: idAlloggio,
          idMensa: idMensa
        }
      }).then(response => {
        if (response.body.respAlloggio != undefined) {
          if (response.body.respAlloggio.rc === 0) {
            //this.form.notaAlloggio = response.body.respAlloggio.data[0].notaDip
            this.form.descrTipo = response.body.respAlloggio.data[0].descrTipo
            this.form.nomeHotel = response.body.respAlloggio.data[0].nomeHotel
            this.form.indirizzo = response.body.respAlloggio.data[0].indirizzo
            this.form.numeroCamera = response.body.respAlloggio.data[0].numeroCamera
            this.form.nomeFile = response.body.respAlloggio.data[0].nomeFile
            this.form.notaSegAlloggio = response.body.respAlloggio.data[0].notaSeg
            this.$set(this.form, 'notaAlloggio', response.body.respAlloggio.data[0].notaDip.split("\\n").join("\n"))
            this.form.statoAlloggio = response.body.respAlloggio.data[0].statoAvanz
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        }
        if (response.body.respMensa != undefined) {
          if (response.body.respMensa.rc === 0) {
            this.form.notaMensa = response.body.respMensa.data[0].notaDip
            this.form.notaSegMensa = response.body.respMensa.data[0].notaSeg
            this.$set(this.form, 'notaMensa', response.body.respMensa.data[0].notaDip.split("\\n").join("\n"))
            this.form.statoMensa = response.body.respMensa.data[0].statoAvanz
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        }
        this.loading = false
        this.showModal = true
      })
    },
    loadMensa: function (idRiga, id) {
      this.$http.get('trasferte/' + this.$store.state.country + '/mensa', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          id: id,
          idRiga: idRiga,
          pag_action: 'BEGIN',
          pag_from: 1,
          pag_for: 20,
          pag_order: 'DD'
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.form.notaMensa = response.body.data[0].notaDip
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    loadUffRep: function (value) {
      this.$http.get('datisoc/' + this.$store.state.country + '/uffrep', {
        params: {
          //cliente: value
          socFat: value
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_uffRep = response.body.data
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
        this.loading = false
      })
    },
    getDoc: function (nomeFile) {
      //let url = ('download/trasferta?fileName=' + nomeFile + '&country=' + this.$store.state.country + '&token=' + sessionStorage.getItem('token'))
      let url = ('download/document?codLang=' + sessionStorage.getItem('codLang') + '&delete=NO' +
        '&fileName=' + nomeFile + '&filePath=PaiCEDEXP' + '&token=' + sessionStorage.getItem('token'))
      let win = window.open(process.env.baseUrlSpring + url, '_blank')
      win.focus()
    },
    isDisabled: function () {
      if (this.trasferta.terminata === 'T' || this.form.id != '') {
        return true
      } else {
        return false
      }
    },
    enableAction: function (action, row) {
      let statoTrasferta = this.trasferta.statoAvanz
      if (this.trasferta.terminata === 'T') {
        return false
      }
      switch (action) {
        case 'send':
          if ((statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '5') && row.statoAvanz === '0') {
            return true
          } else {
            return false
          }
        case 'del':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '5') {
            return true
          } else {
            return false
          }
        case 'sendAll':
          if (statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') {
            // Verifico se ho almeno 1 record modificato
            if (this.daInoltrare !== '0' && this.daInoltrare !== '') {
              // Abilito il pulsate perchè ho un record da inviare
              return true
            } else {
              // Ho già inviato tutto
              return false
            }
          } else {
            return false
          }
        case 'add':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') {
            return true
          } else {
            return false
          }
      }
      return false
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
          return 'riv-circle'
        default:
          return ''
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/el-table.less";
@import "../../assets/less/el-pagination.less";
@import "../../assets/less/el-button.less";

.diario {
  .action {
    height: 53px;
    text-align: right;
    padding-top: 10px;
  }

  height: 100%;
  //min-width: 1250px;
  max-width: 100%;

  .el-checkbox {
    margin-bottom: 0px;
    margin-top: 10px;

    .el-checkbox__inner {
      border-radius: 0px;
    }

    &.is-checked {
      .el-checkbox__inner {
        background-color: @greenRiva;
        border-color: @greenRiva;
      }
    }
  }
}

.row {
  &.row-error {
    .my-label {
      color: red !important;
    }

    .my-input {
      border: 1px solid red !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Trasferte/Diario.vue